import * as styles from "./styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Link } from "../../atoms/link";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
export const HamburgerHeader = ({ titleM = M.empty(), imageSrc, closeDrawer, route, anonymous, }) => (React.createElement(Link, { href: anonymous
        ? `${config.standardPageRouteFragments.signIn}?returnURL=${route}`
        : route },
    React.createElement(RenderMaybe, null, M.map((title) => (React.createElement("div", { id: `#${title}`, onClick: closeDrawer, className: styles.menuHeaderWrapper },
        React.createElement("img", { className: styles.watchLaterBtn, src: imageSrc }),
        React.createElement(Typography, { classNameM: M.of(styles.watchLaterLbl), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, title)))), titleM))));

